import { t_status, IEvent, IEventTemplate } from '../types/event_type';

const logStrategy: Record<t_status, 'info' | 'debug' | 'warn' | 'error'> = {
  success: 'info',
  info: 'debug',
  warning: 'warn',
  failure: 'error',
  fatal: 'error'
};

export function consoleReporter(event: IEvent): Readonly<IEventTemplate> {
  console.groupCollapsed(`${(event.status + '').toUpperCase()} ${event.site} / ${event.source} / ${event.action}`);

  const data: Record<string, unknown> = (event.data || {}) as Record<string, unknown>;
  const context = data['message'] || data;

  if (event.reason) {
    console[logStrategy[event.status] || 'debug'](event.reason);
  }

  console.table({
    Site: event.site,
    Status: event.status,
    Source: event.source,
    Action: event.action,
    Namespace: event.ns,
    Order: event.order
  });

  if (event.producer) {
    console.dir(event.producer);
  }

  console.trace(context);
  console.groupEnd();
  return event;
}
